import { createFileRoute } from "@tanstack/react-router";
import { PracticeMasterPage, practiceMasterHead } from "@/components/site/PracticeMasterPage";
import { practiceMasterPages } from "@/data/practice-master-pages";

const page = practiceMasterPages[6];
export const Route = createFileRoute("/practice-areas/employment-law-lawyer-seo")({
  head: () => practiceMasterHead(page),
  component: () => <PracticeMasterPage page={page} />,
});
